<template>
    <div>
        <div class="text-info" style="cursor: pointer" @click="getData(row)" v-if="row.type === walletTransactionType.CHARGE_BY_TRANSFER">
            <span v-if="loading" class="spinner-border spinner-border-sm"></span>
            <i  v-else class="fas fa-info"></i>
        </div>

        <div  v-if="row.type === walletTransactionType.CHARGE_BY_TRANSFER" class="modal fade" :id="`show_details_${row.id}`" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
              aria-hidden="true">

            <div
                class="modal-dialog modal-lg modal-dialog-centered"
                role="document"
            >
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="text-center">توضیحات</div>
                        <form class="mt-5 mx-5 mb-2">
                            <div class="row my-2 bg-white p-1">

                                <div class="col-12 col-md-4 my-2">
                                    <div class="text-left">{{ $t('label.total_amount') }}</div>
                                    <input class="form-control"
                                           :value="row.amount"
                                           disabled
                                    >
                                </div>
                                <div class="col-12 col-md-4 my-2">
                                    <div class="text-left">{{ $t('label.status') }}</div>
                                    <input
                                        :class="`form-control text-white bg-${walletTransactionStatusVariant(row.status)}`"
                                        :value="walletTransactionStatusStr.get(row.status) + (false ? ' (' + $t('label.reversal') + ')' : '')"
                                        disabled
                                    >
                                </div>

                                <div class="col-12 col-md-4 my-2">
                                    <div class="text-left">{{ $t('label.payment_date') }}</div>
                                    <input class="form-control"
                                           style="direction: ltr;"
                                           :value="row.created_at"
                                           disabled
                                    >
                                </div>

                                <div class="col-12 col-md-12 my-2">
                                    <div class="text-left">{{ $t('label.description') }}</div>

                                    <textarea class="form-control" :value="fetchTransfer.transfer_description" disabled rows="4"></textarea>
                                </div>

                            </div>

                            <table
                                class="table table-bordered bg-white"
                            >
                                <tr>
                                    <td
                                        v-text="
                                                    $t(
                                                        'wallets.receipt.user_to'
                                                    )
                                                "
                                    ></td>
                                    <td
                                        v-text="
                                                    $t(
                                                        'wallets.receipt.user_from'
                                                    )
                                                "
                                    ></td>

                                    <td
                                        v-text="
                                                    $t(
                                                        'wallets.receipt.wallet_id_from'
                                                    )
                                                "
                                    ></td>
                                    <td
                                        v-text="
                                                    $t(
                                                        'wallets.receipt.wallet_id_to'
                                                    )
                                                "
                                    ></td>

                                </tr>
                                <tr>
                                    <td  v-if="fetchTransfer.from">{{ fetchTransfer.from.user }}</td>
                                    <td v-if="fetchTransfer.to">{{ fetchTransfer.to.user }}</td>
                                    <td  v-if="fetchTransfer.from">{{ fetchTransfer.from.wallet_id }}</td>
                                    <td  v-if="fetchTransfer.to">{{ fetchTransfer.to.wallet_id }}</td>
                                </tr>
                            </table>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import {walletService} from "@/common/api.service";
import $ from "jquery";
import {walletTransactionType} from "@/constants/walletTransactionType";
import {walletTransactionStatusStr, walletTransactionStatusVariant} from "@/constants/walletTransactionStatus";
import Vue from "vue";

export default Vue.extend({
    name: "transaction-actions",
    computed: {
        walletTransactionStatusStr() {
            return walletTransactionStatusStr
        },
        walletTransactionType() {
            return walletTransactionType
        }
    },
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        },
    },

    data() {
        return {
            fetchTransfer: {},
            loading: false,
        }
    },

    methods: {
        walletTransactionStatusVariant,
        getData(row) {
            this.fetchTransfer = {};
            this.loading = true;
            walletService.getSettlementDetailAyande(row.id).then(res => {
                this.fetchTransfer = res.data.data;
                $(`#show_details_${row.id}`).modal("show")
            }).catch(({response}) => {
                this.showMsg(form, 'danger', response.data.message);
            }).finally(() => {
                this.loading = false;
            });

        }
    },
})
</script>

<style scoped>

</style>